import useScrollFade from '../../../hooks/useScrollFade';

const benefits = [
  {
    number: '01',
    title: 'Executive-Level Expertise Without the Full-Time Cost',
    description:
      'Get senior CTO-level strategy, architecture decisions, and technical leadership — typically at 20–30% of the cost of a full-time hire.',
    accent: 'border-l-teal-500',
    numColor: 'text-teal-100',
    bg: 'bg-teal-50/40',
  },
  {
    number: '02',
    title: 'Flexible Engagement on Your Timeline',
    description:
      'Whether you need guidance for a critical growth phase, a product launch, or ongoing oversight, a fractional CTO scales with your needs — no long-term commitment required.',
    accent: 'border-l-amber-400',
    numColor: 'text-amber-100',
    bg: 'bg-amber-50/40',
  },
  {
    number: '03',
    title: 'Immediate Impact, Zero Ramp-Up Friction',
    description:
      'With 20+ years of enterprise experience, you get a leader who can assess your tech stack, align your team, and drive results from day one.',
    accent: 'border-l-emerald-500',
    numColor: 'text-emerald-100',
    bg: 'bg-emerald-50/40',
  },
];

const WhyFractionalSection = () => {
  const header = useScrollFade();
  const para = useScrollFade({ delay: 100 });
  const b0 = useScrollFade({ delay: 200 });
  const b1 = useScrollFade({ delay: 300 });
  const b2 = useScrollFade({ delay: 400 });

  const benefitRefs = [b0, b1, b2];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">

        {/* Headline */}
        <div ref={header.ref} className={`mb-8 ${header.fadeClass}`}>
          <p className="text-sm font-bold uppercase tracking-widest text-teal-500 mb-3">
            Value Proposition
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
            Why Companies Choose<br />Fractional CTO Leadership
          </h2>
          <div className="h-0.5 w-16 bg-teal-500 rounded-full" />
        </div>

        {/* Short paragraph */}
        <p
          ref={para.ref}
          className={`text-gray-600 text-lg leading-relaxed max-w-2xl mb-14 ${para.fadeClass}`}
        >
          Hiring a full-time CTO typically costs $250k+ per year — yet many companies only need
          senior technical leadership during key phases of growth. A fractional CTO delivers
          the same strategic value at a fraction of the investment.
        </p>

        {/* Key benefits */}
        <div className="flex flex-col gap-0">
          {benefits.map((benefit, index) => {
            const { ref, fadeClass } = benefitRefs[index];
            const isLast = index === benefits.length - 1;
            return (
              <div
                key={index}
                ref={ref}
                className={`flex gap-8 items-start py-10 pl-6 rounded-xl border-l-4 ${benefit.accent} ${benefit.bg} ${!isLast ? 'mb-4' : ''} ${fadeClass}`}
              >
                <span className={`text-5xl font-black leading-none select-none w-16 shrink-0 pt-1 ${benefit.numColor}`}>
                  {benefit.number}
                </span>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default WhyFractionalSection;
